import { IconPropsType } from './types/IconsProps.type';

type LogoutIconProps = IconPropsType;

export const LogoutIcon = ({
  width = 21,
  height = 20,
  className = '',
  style = {},
  fillColor = 'currentColor',
}: LogoutIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4.82743C3 3.54194 4.0421 2.49985 5.32759 2.49985H8.77586C9.10914 2.49985 9.37931 2.77002 9.37931 3.1033C9.37931 3.43657 9.10914 3.70674 8.77586 3.70674H5.32759C4.70865 3.70674 4.2069 4.20849 4.2069 4.82743V15.1723C4.2069 15.7912 4.70865 16.293 5.32759 16.293H8.77586C9.10914 16.293 9.37931 16.5631 9.37931 16.8964C9.37931 17.2297 9.10914 17.4998 8.77586 17.4998H5.32759C4.0421 17.4998 3 16.4578 3 15.1723V4.82743ZM13.5216 6.12487C13.7572 5.88921 14.1393 5.88921 14.375 6.12487L17.8233 9.57315C18.0589 9.80881 18.0589 10.1909 17.8233 10.4265L14.375 13.8748C14.1393 14.1105 13.7572 14.1105 13.5216 13.8748C13.2859 13.6392 13.2859 13.2571 13.5216 13.0214L15.9397 10.6033H7.91379C7.58052 10.6033 7.31035 10.3331 7.31035 9.99985C7.31035 9.66657 7.58052 9.3964 7.91379 9.3964H15.9397L13.5216 6.97827C13.2859 6.74261 13.2859 6.36053 13.5216 6.12487Z"
        fill={fillColor}
      />
    </svg>
  );
};
